<template lang="html">
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 text-xs-center>
        <h1>Contact</h1>
      </v-flex>
      <v-flex xs6 class="hidden-md-and-down" text-xs-center pa-1>
        <v-card class="address-element">
          <v-flex xs12 text-xs-center pa-2>
            <h2 class="primary--text font-weight-light">Address</h2>
          </v-flex>
          <v-divider></v-divider>
          <v-card-text class="pa-5">
              <h2>Saritha Sangeetham</h2>
              <div class="subheading">#3-2-7, 4th Line,</div>
              <div class="subheading">Rajagopalapuram,</div>
              <div class="subheading">Naidupeta,</div>
              <div class="subheading">Nellore, Andhra Pradesh.</div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6 class="hidden-md-and-down" text-xs-center pa-1>
        <v-card>
          <v-flex xs12 text-xs-center pa-2>
            <h2 class="primary--text font-weight-light">Map</h2>
          </v-flex>
          <v-divider></v-divider>
          <!-- <gmap-autocomplete @place_changed="setPlace"></gmap-autocomplete> -->
          <!-- <gmap-map  :center="center" :zoom="12" class="map-element">
            <gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" @click="center=m.position"></gmap-marker>
          </gmap-map> -->
          <v-img :src="mapsImage" @click="mapsSelector" class="pointer">
          </v-img>
        </v-card>
      </v-flex>
      <v-flex xs12 class="hidden-md-and-up" text-xs-center pa-1>
        <v-card class="address-element">
          <v-flex xs12 text-xs-center pa-2>
            <h2 class="primary--text font-weight-light">Address</h2>
          </v-flex>
          <v-divider></v-divider>
          <v-card-text class="pa-5">
              <h2>Saritha Sangeetham</h2>
              <div class="subheading">#3-2-7, 4th Line,</div>
              <div class="subheading">Rajagopalapuram,</div>
              <div class="subheading">Naidupeta,</div>
              <div class="subheading">Nellore, Andhra Pradesh.</div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="hidden-md-and-up" text-xs-center pa-1>
        <v-card>
          <v-flex xs12 text-xs-center pa-2>
            <h2 class="primary--text font-weight-light">Map</h2>
          </v-flex>
          <v-divider></v-divider>
          <!-- <gmap-autocomplete @place_changed="setPlace"></gmap-autocomplete> -->
          <!-- <gmap-map  :center="center" :zoom="12" class="map-element">
            <gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" @click="center=m.position"></gmap-marker>
          </gmap-map> -->
          <v-img :src="mapsImage" @click="mapsSelector" class="pointer">
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<!-- AIzaSyACPa5TwpPJxejK8hBMDD01SkaD8jfGKsw -->
<script>
import mapsImage from '@/assets/images/map-image.png'
export default {
  data() {
    return {
      mapsImage: mapsImage,
      center: {
        lat: 13.906476,
        lng: 79.897707
      },
      markers: [],
      places: [],
      currentPlace: null
    }
  },
  mounted() {
    // Refernce https://alligator.io/vuejs/vue-google-maps/
    // this.geolocate()
    // const marker = {
    //   lat: this.center.lat,
    //   lng: this.center.lng
    // }
    // this.markers.push({
    //   position: marker
    // })
  },
  methods: {
    mapsSelector() {
      /* if we're on iOS, open in Apple Maps */
      if ((navigator.platform.indexOf('iPhone') !== -1) ||
        (navigator.platform.indexOf('iPad') !== -1) ||
        (navigator.platform.indexOf('iPod') !== -1)) {
        window.open(`maps://maps.google.com/maps?daddr=${this.center.lat},${this.center.lng}&amp;ll=`)
      } else {
        /* else use Google */
        window.open(`https://maps.google.com/maps?daddr=${this.center.lat},${this.center.lng}&amp;ll=`)
      }
    }
  }
}
</script>

<style lang="css" scoped>
.map-element{
  width:100%;
  height: 200px;
}
.address-element{
  width:100%;
  height: 250px;
}
</style>
